'use client';

import { c as _c } from "react/compiler-runtime";
import { HeroMarketLoading } from '../HeroMarketSection/states';
import { useMarketRoute } from './MarketRouteContext';

/** The market hero fallback, with the resolved market's symbols. */
const MarketRouteHeroLoading = () => {
  const $ = _c(3);
  const route = useMarketRoute();
  const t0 = route?.loanSymbol;
  const t1 = route?.collateralSymbol;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = <HeroMarketLoading loanSymbol={t0} collateralSymbol={t1} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default MarketRouteHeroLoading;